<template>
  <div class="address">
    <van-nav-bar
      :title="title"
      left-text=""
      right-text=""
      left-arrow
      @click-left="back"
    />

    <van-address-edit
      :area-list="areaList"
      :address-info="addressInfo"
      show-delete
      show-set-default
      @save="onSave"
      @delete="onDelete"
    />

  </div>
</template>

<script>
import { addAddress, myAddressDetail, editAddress, deleteAddress } from '@/api/address'
import { NavBar, AddressEdit, Toast } from 'vant'
import { areaList } from '@vant/area-data';
import AddressPanel from './components/AddressPanel'

export default {
  name: 'Address',
  components: {
    [NavBar.name]: NavBar,
    [AddressEdit.name]: AddressEdit,
    AddressPanel
  },
  data () {
    return {
      addressId: undefined,
      addressInfo: {},
      title: '',
      areaList
    }
  },
  computed: {
  },
  created () {
    this.addressId = this.$route.query.address_id || ''
    this.title = this.addressId ? '编辑收货地址' : '新增收货地址'
    if (this.addressId) {
      this.getAddress()
    }
  },
  methods: {
    async getAddress () {
      const res = await myAddressDetail(this.addressId)
      this.addressInfo = {
        'id': res.data.uuid,
        'name': res.data.name,
        'tel': res.data.tel,
        'province': res.data.province,
        'city': res.data.city,
        'county': res.data.county,
        'addressDetail': res.data.detail,
        'isDefault': res.data.is_default,
        'areaCode': res.data.area_code,
      }
    },
    async onSave (content) {
      const address = {
        'name': content.name,
        'tel': content.tel,
        'province': content.province,
        'city': content.city,
        'county': content.county,
        'detail': content.addressDetail,
        'is_default': content.isDefault,
        'area_code': content.areaCode,
      }

      Toast.loading({ duration: 0, forbidClick: true, loadingType: 'spinner' })
      if (this.addressId) {
        // 编辑
        await this.edit(address)
      } else {
        // 新增
        await this.add(address)
      }
      Toast.clear()
      // this.$router.push('/my/address')
      this.$router.back()
    },
    async add (address) {
      await addAddress(address)
    },
    async edit (address) {
      await editAddress(this.addressId, address)
    },
    async onDelete() {
      await deleteAddress(this.addressId)
      Toast('删除成功')
      this.$router.back()
      // this.$router.push('/my/address')
    },
    back () {
      this.$router.back()
    }
  }
}
</script>

<style scoped lang="scss">
.address {
}
</style>
